/* Hook encargado de eliminar una imagen del vehiculo

Autor: Benjamín León
Fecha: 2024-12-01
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch'

import { makeUrlImagesReorder } from './connectionData'

interface ApiParams {
  ids: string[]
  vehicle_id: string
  registry: string
}

const useImagesReorder = () => {
  const [errorImage, setErrorImage] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const imagesReorder = async (ids: string[], vehicle_id: string, registry: boolean) => {
    setLoading(true)

    try {
      const apiParams: ApiParams = { ids: ids, vehicle_id: vehicle_id, registry: registry ? '1' : '0' }
      const apiUrl = makeUrlImagesReorder()
      await customPost(apiUrl, apiParams)
      setErrorImage(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorImage(err)
      } else {
        setErrorImage(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorImage, loading, imagesReorder }
}
export default useImagesReorder
